import React from "react";

export const NavButton = ({ disabled, className = "", style = {}, children, onClick }) => {

  return (
    <button
      disabled={disabled}
      className={`${className} button-text-primary`}
      onClick={onClick}
      style={style}
    >
      {children || "Кнопка"}
    </button>
  );
};